import { render, staticRenderFns } from "./ScoreboardNews.vue?vue&type=template&id=1ab66941&scoped=true&"
import script from "./ScoreboardNews.vue?vue&type=script&lang=js&"
export * from "./ScoreboardNews.vue?vue&type=script&lang=js&"
import style0 from "./ScoreboardNews.vue?vue&type=style&index=0&id=1ab66941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab66941",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VImg})
